import { z } from "zod";
import { ValidationUtils } from "./utils";

export const PartitionSchema = z.object({
    dimensions: ValidationUtils.nonEmptyDimensions(),
});
